module.exports = __webpack_public_path__ + "static/media/suicidePreventionAction.9b537f8c.jpg";